// api/userApi.js
import axiosInstance from './axiosInstance';

// Get all users
export const fetchUsers = (isSuperadmin = false) => axiosInstance.get(isSuperadmin ? '/superadmin/users' : '/admin/users');

// Delete a specific user
export const deleteUser = (id) => axiosInstance.delete(`/admin/users/${id}`);

// Update a specific user
export const updateUser = (id, data) => axiosInstance.put(`/admin/users/${id}`, data);
